import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import U2000ActionBtn from "../../../u2000Core/components/buttons/U2000ActionBtn";
import U2000ResponsiveToolbar from "../../../u2000Core/components/toolbar/U2000ResponsiveToolbar";
import { FaArrowLeft, FaFileExcel, FaFilePdf } from "react-icons/fa";
import { NS } from "../../U3125";

export interface U3125ArAgingReportToolbarProps {
  onExportExcel: () => void;
  onExportPdf: () => void;
  exportDisabled: boolean;
  isExportingExcel: boolean;
  isExportingPdf: boolean;
}

const U3125ArAgingReportToolbar: React.FC<U3125ArAgingReportToolbarProps> = ({
  onExportExcel,
  onExportPdf,
  exportDisabled,
  isExportingExcel,
  isExportingPdf,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const actions = [
    {
      key: "back",
      label: t("btnArAgingBackToList", { ns: NS }),
      hasRole: true,
      handleClick: () => navigate("/U3125"),
      icon: FaArrowLeft,
      Component: U2000ActionBtn,
    },
    {
      key: "exportExcel",
      label: t("btnExportArAgingExcel", { ns: NS }),
      hasRole: true,
      handleClick: onExportExcel,
      disabled: exportDisabled || isExportingExcel,
      icon: FaFileExcel,
      Component: U2000ActionBtn,
    },
    {
      key: "exportPdf",
      label: t("btnExportArAgingPdf", { ns: NS }),
      hasRole: true,
      handleClick: onExportPdf,
      disabled: exportDisabled || isExportingPdf,
      icon: FaFilePdf,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};

export default U3125ArAgingReportToolbar;
